import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { motion } from "framer-motion";

export default function Hero() {
  const data = useStaticQuery(graphql`
    query HeroQuery {
      prismicHomepage {
        data {
          hero_image {
            gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
            alt
          }
          hero_paragraph {
            text
          }
          schedule_cta {
            text
          }
        }
      }
    }
  `);
  const heroParagraph = data.prismicHomepage.data["hero_paragraph"].text;
  const scheduleCta = data.prismicHomepage.data["schedule_cta"].text;
  const heroImage = data.prismicHomepage.data["hero_image"].gatsbyImageData;

  return (
    <div className="px-6 lg:px-12">
      <div className="flex flex-col max-w-6xl mx-auto mb-6 relative px-6 lg:px-6">
        <div className="flex flex-col md:flex-row items-center">
          <div className="text-blue-dark flex flex-col mr-0 md:mr-16">
            <div className="md:-mt-4">
              <motion.h1
                initial={{ opacity: 0, x:-15 }}
                animate={{
                  opacity: 1,
                  x:0,
                  transition: { delay: 0.3, duration: 0.35 },
                }}
                className="text-4xl text-center md:text-left md:text-4xl  lg:text-6xl mb-4 md:mb-5 max-w-lg mx-auto md:max-w-2xl font-light "
              >
                The best{" "}
                <span className="text-4xl lg:text-6xl font-bold">
                  digital banking
                </span>{" "}
                experience from end to end.
              </motion.h1>
              <motion.p
                initial={{ opacity: 0,x:-15 }}
                animate={{
                  opacity: 1,
                  x:0,
                  transition: { delay: 0.6, duration: 0.4 },
                }}
                className="max-w-lg mx-auto mb-8 md:mb-12 md:mx-0 text-base text-blue-dark font-normal text-center md:text-left"
              >
                {heroParagraph}
              </motion.p>
            </div>
            <div className=" pb-4 md:self-stretch">
              <motion.div
                initial={{ opacity: 0, x:-10 }}
                animate={{
                  opacity: 1,
                  x:0,
                  transition: { delay: 0.9, duration: 0.5 },
                }}
                className="hidden md:flex -ml-1 justify-center md:justify-start"
              >
                <Link
                  to="/contact"
                  className="hoverShadow text-base font-medium pb-3 pt-2 mr-6 px-7 bg-blue text-white rounded-full"
                >
                  {scheduleCta}
                </Link>
              </motion.div>
            </div>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y:0, transition: { delay: 1.4, duration: 0.5 } }}
            className="w-full md:w-96 self-center md:-mt-4"
          >
            <GatsbyImage
              image={heroImage}
              alt={data.prismicHomepage.data["hero_image"].alt}
            />
          </motion.div>
          <div className="my-6 md:hidden flex -ml-1 justify-center md:justify-start">
            <Link
              to="/contact"
              className="hoverShadow text-base font-medium pb-3 pt-2 ml-4 px-7 bg-blue text-white rounded-full"
            >
              {scheduleCta}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
